import React from 'react'
import Image from 'components/image/image'
import './block-text-number.sass'

const getImage = (img) => {
    const [url, alignment] = img.split('|');
    const isCentered = alignment === 'center';

    return (
        <div className={`k-max-width--1 ${isCentered ? 'text-center' : ''}`}>
            <Image image_url={`content/${url}`}
                   className="img-fluid"
                   alt={url}/>
        </div>
    );
}

const getMarkDown = (md) => (
  <div
    dangerouslySetInnerHTML={{ __html: md }} />
)

const getContent = (contents) => {
  return contents.map((content, i) => {
    return (
      <React.Fragment key={i}>
        {
          content.indexOf('content/') > -1
            ? getImage(content.split('content/').pop(1))
            : getMarkDown(content)
        }
      </React.Fragment>
    )
  })
}

const BlockTextNumber = ({ data }) => {
  return (
    <section className="BlockTextNumber container-fluid">
      <div className={`BlockTextNumber__space row 
                        ${data.classes ? data.classes : ''}
                        `}>
        <div className="col-md-12">
          <div className="d-flex">
            <span className="BlockTextNumber__number mr-3">{data.number}</span>
            { data.content ?
                getContent(data.content) :
                <h2 className="mt-2">{data.title}</h2> }
          </div>
          <div>
            {getContent(data.subtext)}
          </div>
        </div>
      </div>
    </section>
  )
}

export default BlockTextNumber
